import { render, staticRenderFns } from "./LmCodificatorsNewOrEdit.vue?vue&type=template&id=fc4b971a&"
import script from "./LmCodificatorsNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmCodificatorsNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports